import { images } from '../constants/images';
import { PageRoutes } from './page-routes';
import { Page } from './pages-types';
import { FormattedString } from '../i18n/useMessages';

export const significanceOfMaghMessages = {
  'significance-of-magh.subtitle': 'The sacred gathering of Magh.',
  'significance-of-magh.hero-image-alt':
    'Devotees taking a holy dip at the Triveni Sangam during Magh Mela.',
  'significance-of-magh.summary':
    'Magh Mela, held annually in the auspicious Hindu month of Magh (January–February), is a time-honored gathering of devotees on the banks of the sacred rivers to bathe, meditate, and seek spiritual upliftment.',
  'significance-of-magh.content': `
    <p>
      The Magh Mela, often regarded as the smaller yet equally profound cousin
      of the Kumbh, is celebrated each year at the sacred confluence of the
      Ganga, Yamuna, and the mystical Saraswati rivers in Prayagraj.
    </p>
    <paragraph>
      Rooted in ancient tradition, the month of Magh has been considered supremely
      auspicious for spiritual practices. Hindu scriptures, such as the
      Puranas, emphasize that bathing in the holy rivers during this period,
      especially at the Triveni Sangam, washes away sins and opens the path to
      liberation (moksha).
    </paragraph>
    <paragraph>
      The Magh Mela is not merely a ritual of bathing, but a sacred congregation
      of saints, sages, ascetics, and householders alike. People from across India
      and beyond come together to perform penance, observe austerities, recite
      scriptures, and immerse themselves in devotion. Many undertake the Kalpavas —
      a vow of simplicity, staying by the riverbanks for the entire month of Magh,
      engaging solely in prayer, meditation, and service.
    </paragraph>
    <paragraph>
      The mela symbolizes the timeless continuity of faith and the rhythm of cosmic
      cycles, reminding humanity of the union between the finite and the infinite.
      Just as the rivers converge at the Sangam, the Magh Mela represents the
      convergence of body, mind, and spirit in the pursuit of truth.
    </paragraph>
    <paragraph>
      In a symbolic sense, the rivers signify the channels of human consciousness,
      and their confluence symbolizes the unity of knowledge, devotion, and action
      within one’s self. The Magh Mela thus inspires individuals to purify their
      inner being and to walk the path of dharma with renewed clarity.
    </paragraph>
  `,
};

export const significanceOfMaghPage: Page = {
  title: 'camp67-navigation.kumbh-2025.sacred-gathering-of-magh-mela',
  subtitle: 'significance-of-magh.subtitle',
  path: PageRoutes.sacredGatheringOfMaghMela,
  heroImage: images['sacred-gathering-of-magh-mela-hero'],
  heroImageAlt: 'significance-of-magh.hero-image-alt',
  readingTime: 3,
  summary: <FormattedString message="significance-of-magh.summary" />,
  content: (
    <FormattedString
      message="significance-of-magh.content"
      components={{
        paragraph: <p className="mt-5" />,
      }}
    />
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.camp67AndKumbh),
    s.getPageOrThrow(PageRoutes.mauniAmavasya),
  ],
};
